import React, { useEffect, useState } from "react"
import RouteTracking from "./route-traking"
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllroute, routeSelector } from "../../api/route";
import { driverSelector, fetchOnedriver, updatedriver } from "../../api/driver";

export default function Demo() {
    const navigate = useNavigate();
    const { all_route } = useSelector(routeSelector);
     const {driverData} = useSelector(driverSelector);
    const disapatch = useDispatch();
    const [routesWithVehicles, setRoutesWithVehicles] = useState([]);
     const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
    disapatch(fetchAllroute());
    const driverid = localStorage.getItem("Driver");
    disapatch(fetchOnedriver(driverid));
  }, [disapatch]);

  useEffect(() => {
    if (!all_route || !driverData?.vehicleId) return;

    // Map routes to include assigned vehicle info if matched
    const augmentedRoutes = all_route.map(route => {
      // Find vehicle assigned to this route
     const assignedVehicle = driverData.vehicleId.find(vehicle =>
  vehicle.selected_schedules?.some(sch => sch.route.toString() === route._id.toString())
); 
console.log("Route ID:", route._id.toString());
driverData.vehicleId.forEach(vehicle => {
  console.log("Vehicle Reg:", vehicle.reg_no);
  vehicle.selected_schedules?.forEach(sch => {
    console.log("Schedule Route:", sch.route.toString());
  });
});

      if (assignedVehicle) {
        const routeSchedule = assignedVehicle.selected_schedules.find(sch => sch.route.toString() === route._id.toString());
        return {
          ...route,
          assignedVehicle: {
            reg_no: assignedVehicle.reg_no,
            price_per_trip: routeSchedule?.price_per_Trip ?? routeSchedule?.pricePerTrip ?? null,
          }
        };
      }
      return route;
    });

    setRoutesWithVehicles(augmentedRoutes);
  }, [all_route, driverData]);


    const handleClick = (id) => {
        navigate(`/routeindepth/${id}`);
    };

    console.log(all_route)
    useEffect(() => {
        disapatch(fetchAllroute())

    }, [])

     const filteredRoutes = routesWithVehicles.filter((route) => {
    const from = route?.from_location?.name?.toLowerCase() || "";
    const to = route?.to_location?.name?.toLowerCase() || "";
    const stops =
      route?.stops?.map((stop) => stop?.stop_location?.name?.toLowerCase()) ||
      [];

    const query = searchQuery.toLowerCase();
    return (
      from.includes(query) ||
      to.includes(query) ||
      stops.some((stop) => stop.includes(query)) ||
      route?.assignedVehicle?.reg_no?.toLowerCase().includes(query)
    );
  });
   

    return (

        <>
            <div>
                <section className="text-gray-600 body-font mt-24">
                    <div className="container px-5 py-24 mx-auto">
                        <div className="flex flex-wrap w-full mb-20 flex-col items-center text-center">
                            <h1 className="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">Routes Available</h1>
                              {/* 🔹 Search Input */}
          <div className="relative mt-4 w-[360px] max-w-full">
  <input
    type="text"
    placeholder="Search by location, stop, or vehicle reg no..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    className="pl-10 pr-4 py-2 border rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-indigo-500"
  />
  {/* Search Icon */}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 21l-4.35-4.35M10 18a8 8 0 100-16 8 8 0 000 16z"
    />
  </svg>
</div>

                        </div>
           <div className="flex flex-wrap -mt-16">
  {routesWithVehicles.length === 0
    ? <p className="text-center w-full mt-10">Loading or no routes available</p>
    : filteredRoutes.map(route => (
      <div key={route._id} className="xl:w-1/3 md:w-1/2 p-4 w-full" onClick={() => handleClick(route._id)}>
        <div className="border border-gray-200 p-6 rounded-lg">
          <h2 className="text-lg text-gray-900 font-medium title-font mb-2">
            {route?.from_location?.name} - {route?.to_location?.name}
          </h2>
          <p className="leading-relaxed text-base">
            Distance: {route.no_of_kms} km
          </p>
          <p className="leading-relaxed text-sm text-gray-500">
            Stops: {route?.stops?.length
              ? route.stops.map(stop => stop?.stop_location?.name || "Unknown Stop").join(", ")
              : "No stops in between"}
          </p>
       {route.assignedVehicle ? (
            <div className="mt-2 p-2 bg-gray-100 rounded">
              <p className="text-sm font-semibold text-gray-700">Vehicle Reg No: {route.assignedVehicle.reg_no}</p>
             <p className="text-sm text-gray-600">
  Price Per Trip: ₹{Number(route.assignedVehicle.price_per_trip?.$numberDecimal || route.assignedVehicle.price_per_trip).toFixed(2)}
</p>

            </div>
          ) : (
            <p className="mt-2 text-sm italic text-gray-400">No vehicle assigned</p>
          )} 
        </div>
      </div>
    ))}
</div>

                    </div>
                </section>
            </div>
        </>
    )
}

